export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13820.6aa0cf32.jpg";